import React, { FC } from 'react';
import styled from 'styled-components';
import { OverflowTooltip } from '@adsk/alloy-react-tooltip';
import { CellProps } from '../../../utils';

const AccountNameContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
});

export const AccountNameCell: FC<CellProps> = ({ row, value }) => {
  return (
    <AccountNameContainer data-testid={`AccountName:${row.original.id}`}>
      <OverflowTooltip triggerTarget={OverflowTooltip.TRIGGER_TARGETS.TOOLTIP}>
        {value}
      </OverflowTooltip>
    </AccountNameContainer>
  );
};
